import type { CommandArgs, CommandName } from "@bentolabs/points-worker";

import {
  BuildCommandContent,
  SendMessageParams,
} from "@bentolabs/points-worker";
import { useMutation } from "@tanstack/react-query";
import invariant from "tiny-invariant";
import { useAccount, useWalletClient } from "wagmi";

import { catchError } from "shared/ui/toast";

type Params = {
  name: CommandName;
  args: CommandArgs;
};

export const useBuildCommandMutation = () => {
  const { address } = useAccount();
  const { data: wc } = useWalletClient();
  return useMutation({
    mutationFn: async (params: Params) => {
      const { name, args } = params;
      invariant(address, "useBuildCommandMutation. address is undefined");
      invariant(wc, "useBuildCommandMutation. wc is undefined");
      const content: BuildCommandContent = {
        account: address.toLowerCase(),
        command: { name, args },
      };

      const response = await fetch("/points/build-command", {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(content),
      });

      if (!response.ok) {
        const { error } = await response.json();
        throw new Error(error);
      }

      const { message }: { message: string } = await response.json();

      const signature = await wc.signMessage({
        message,
        account: address,
      });

      const sendMessageContent: SendMessageParams = { message, signature };
      const sendCommandResponse = await fetch("/points/send-command", {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(sendMessageContent),
      });

      if (sendCommandResponse.ok) {
        return;
      } else {
        throw new Error(await sendCommandResponse.json());
      }
    },

    onError: catchError,
  });
};
